import Image from 'next/image';
import Link from 'next/link';

const Terms = () => {
  return (
    <div>
      <div role="banner" className="header-small-wrapper w-nav">
        <div className="container-default w-container">
          <div className="header-small-content-wrapper">
            <Link href="/" className="header-small-logo-link w-nav-brand">
              <Image
                src="/images/logo.svg"
                alt="Logo - Brandymail.com"
                className="header-logo"
                height={50}
                width={150}
                priority
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="section utility-page">
        <div className="container-default width-100 w-container">
          <div className="position-relative z-index-1">
            <div className="inner-container _765px center">
              <div className="inner-container _600px---mbl center">
                <div className="mg-bottom-45px">
                  <div className="inner-container _765px center">
                    <div className="text-center">
                      <h1 className="display-1 color-neutral-100 mg-bottom-16px">Privacy Policy</h1>
                    </div>
                  </div>
                </div>
                <div className="card log-in-form-block w-form text-200 color-neutral-800">
                  <p>Last updated: 1-16-25</p>
                  <p>
                    Thank you for choosing to be part of our community at Brandymail.com
                    (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;). We
                    are committed to protecting your personal information and your right to privacy.
                    If you have any questions or concerns about our policy, or our practices with
                    regards to your personal information, please contact us at support@brandymail.com.
                  </p>
                  <p>
                    This Privacy Policy governs the privacy policies and practices of our Website,
                    located at Brandymail.com. Please read our Privacy Policy carefully as it will
                    help you make informed decisions about sharing your personal information with
                    us.
                  </p>
                  <hr />
                  <p>
                    <strong>1. Information We Collect</strong>
                  </p>
                  <p>
                    As a visitor, you can browse our website to find out more about our website. You
                    are not required to provide us with any personal information as a visitor.
                  </p>
                  <p>
                    We collect your personal information when you express an interest in obtaining
                    information about us or our products and services, when you participate in
                    activities on our website or otherwise when you contact us.
                  </p>
                  <hr />
                  <p>
                    <strong>2. How We Use Your Information</strong>
                  </p>
                  <p>We use the information we receive from you for:</p>
                  <ul>
                    <li>Delivering our products or services to you</li>
                    <li>Improving the functionality of our website</li>
                    <li>Understanding and enhancing user experience</li>
                    <li>Responding to communications</li>
                    <li>Marketing and promotional efforts</li>
                  </ul>
                  <hr />
                  <p>
                    <strong>3. Cookie Policy</strong>
                  </p>
                  <p>
                    We use &quot;cookies&quot; to help personalize and maximize your online
                    experience and time online. A cookie is a text file that is either stored in
                    your computer’s memory temporarily (a “session” cookie) or placed on your hard
                    drive (a “persistent” cookie) by a web page server.
                  </p>
                  <hr />
                  <p>
                    <strong>4. Sharing Information with Third Parties</strong>
                  </p>
                  <p>
                    We do not sell, rent or lease your personal information to third parties.
                    However, we may share data with trusted partners to help us operate our website,
                    conduct our business or service you.
                  </p>
                  <hr />
                  <p>
                    <strong>5. Security of Your Personal Information</strong>
                  </p>
                  <p>
                    Brandymail.com secures your personal information from unauthorized access, use,
                    or disclosure. We strive to take appropriate security measures to protect
                    against unauthorized access to or alteration of your personal information.
                  </p>
                  <hr />
                  <p>
                    <strong>6. Children Under Thirteen</strong>
                  </p>
                  <p>
                    Brandymail.com does not knowingly collect personal information from children
                    under the age of thirteen. If you are under the age of thirteen, you must ask
                    your parent or guardian for permission to use this website.
                  </p>
                  <hr />
                  <p>
                    <strong>7. E-mail Communications</strong>
                  </p>
                  <p>
                    From time to time, Brandymail.com may contact you via email for the purpose of
                    providing announcements, promotional offers, alerts, confirmations, surveys,
                    and/or other general communication.
                  </p>
                  <hr />
                  <p>
                    <strong>8. Changes to this Statement</strong>
                  </p>
                  <p>
                    Brandymail.com reserves the right to change this Privacy Policy from time to
                    time. We will notify you about significant changes in the way we treat personal
                    information by sending a notice to the primary email address specified in your
                    account, by placing a prominent notice on our site, and/or by updating any
                    privacy information on this page.
                  </p>
                  <hr />
                  <p>
                    <strong>9. Contact Information</strong>
                  </p>
                  <p>
                    Brandymail.com welcomes your questions or comments regarding this Statement of
                    Privacy. Please contact us at support@brandymail.com.
                  </p>
                  <hr />
                  <p>
                    <strong>Disclaimer:</strong> This Privacy Policy is provided for informational
                    purposes only and should be customized to meet the specific needs and concerns
                    of Brandymail.com. It is advised to consult with legal counsel to ensure
                    compliance with all applicable laws and regulations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="position-absolute dark-fade---button utility-page-fade"></div>
      </div>
    </div>
  );
};

export default Terms;
